import {foundationAdapter} from "../slices/pageFoundation";


export const {
    selectById: foundationById,
    selectAll: selectAllFoundation,
} = foundationAdapter.getSelectors((state)=> state.foundation);